import React, { FC, useRef, useEffect, useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { Root } from './index.styled';

interface Props {
  icon: IconDefinition;
}

const AbstractIcon: FC<Props> = ({ icon }) => {

  const root = useRef<HTMLDivElement>(null);
  const [iconSize, setIconSize] = useState('0');

  function watchRoot() {
    if (!root.current) return;
    setIconSize(`${root.current.offsetWidth}px`);
  }

  useEffect(watchRoot, [root])

  return (
    <Root ref={root} iconSize={iconSize}>
      <FontAwesomeIcon icon={icon} />
    </Root>
  );
};

export default AbstractIcon;